import type { Document as RichTextDocument } from '@contentful/rich-text-types';

import RichText from '@/components/RichText/RichText';

interface LeadFormTCPAProps {
  text: RichTextDocument;
  className?: string;
}

export function LeadFormTCPA({ text, className }: LeadFormTCPAProps) {
  return (
    <label>
      {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
      <input
        type='hidden'
        id='leadid_tcpa_disclosure'
        name='Terms of Service'
      />
      <RichText title='' content={text} className={className} />
    </label>
  );
}
